import React, { useState } from "react";
import Heading from "../Heading/Heading";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Footer from "../Common/footer/Footer";
import Header from "../Common/header/Header";
import { OnBack } from "../../Component/OnBack/OnBack";
import Animation from "../projects/Animation";

const StartProject = () => {
  const navigate = useNavigate();

  const BASE_URL = process.env.REACT_APP_URL;

  const [state, setState] = useState({
    first_name: "",
    last_name: "",
    company: "",
    existing_website_url: "",
    email: "",
    phone_number: "",
    option: [],
    project_description: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setState((prevProps) => ({
      ...prevProps,
      [name]: value,
    }));
  };

  const handleCheckBox = (e) => {
    const { value } = e.target;
    const index = state.option.indexOf(value);
    if (index == -1) {
      state.option.push(value);
    } else {
      const updatedOptions = state.option.splice(index, 0);
      state.option = updatedOptions;
    }
  };

  const handleSubmit = () => {
    if (state.phone_number?.length < 8 || state.phone_number?.length > 20) {
      return toast.error("Phone number must be between 8 and 20 digits.");
    }
    const {
      first_name,
      last_name,
      phone_number,
      email,
      project_description,
      option,
    } = state;
    if (
      first_name !== "" &&
      last_name !== "" &&
      phone_number !== "" &&
      email !== "" &&
      project_description !== "" &&
      option.length
    ) {
      postOrder();
    } else {
      // alert("kindly fill alll the required fields");
      toast.error("kindly fill all the required fields", {
        style: {
          border: "1px solid #00a621",
          padding: "16px",
          color: "grey",
        },
        iconTheme: {
          primary: "grey",
          opacity: 0,
          secondary: "white",
        },
      });
    }
  };

  const postOrder = async () => {
    const data = {
      email: state.email,
      firstName: state.first_name,
      lastName: state.last_name,
      message: state.project_description,
      projectCategory: state.option,
      company: state.company,
      website: state.existing_website_url,
      phone: state.phone_number,
    };

    axios
      .post(`${BASE_URL}/contact`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log(response.data);
        toast.success("Submitted Successfully");
        setState({
          email: "",
          first_name: "",
          last_name: "",
          project_description: "",
          option: [],
          company: "",
          existing_website_url: "",
          phone_number: "",
        });
        navigate("/");
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error || "Form submission failed!");
      });
  };
  return (
    <div className="p-4 lg:p-10">
      <Header />
      <div
        style={{ backgroundColor: "black" }}
        className="contact_form_container"
      >
        <div
          className="contact_form_wrapper"
          style={{ justifyContent: "center" }}
        >
          <div id="form" method="post">
            <Heading>start a project</Heading>
            <h4 className="formDes">
              Thanks for your interest in working with us. Please complete the
              details below and we’ll get back to you within one or two business
              days.
            </h4>
            <form autoComplete="no" id="form" className="projectForm">
              <div className="field50">
                <div className="inputField">
                  <input
                    type="text"
                    name="first_name"
                    placeholder="First Name *"
                    value={state.first_name}
                    onChange={handleInputChange}
                    id=""
                  />
                </div>
                <div className="inputField">
                  <input
                    autoComplete={false}
                    type="text"
                    name="last_name"
                    placeholder="Last Name *"
                    value={state.last_name}
                    onChange={handleInputChange}
                    id=""
                  />
                </div>
              </div>
              <div className="inputField">
                <input
                  type="text"
                  name="company"
                  value={state.company}
                  onChange={handleInputChange}
                  placeholder="Your Company "
                  id=""
                />
              </div>
              <div className="inputField">
                <input
                  type="text"
                  name="existing_website_url"
                  value={state.existing_website_url}
                  onChange={handleInputChange}
                  placeholder="Existing Website URL"
                  id=""
                />
              </div>
              <div className="inputField">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address *"
                  value={state.email}
                  onChange={handleInputChange}
                  id=""
                />
              </div>
              <div className="inputField">
                <input
                  type="tel"
                  name="phone_number"
                  value={state.phone_number}
                  onChange={handleInputChange}
                  placeholder="Phone Number *"
                  id=""
                />
              </div>
            </form>
            <Heading> what can we help you with?</Heading>
            <div className="checkBoxesSection">
              <div className="checkBoxLft">
                <div className="checkbox">
                  <input
                    id="1"
                    type="checkbox"
                    value="Website Design"
                    onChange={(e) => handleCheckBox(e)}
                  />
                  <label htmlFor="1">Website Design</label>
                </div>
                <div className="checkbox">
                  <input
                    id="2"
                    type="checkbox"
                    value=" Website Development"
                    onChange={(e) => handleCheckBox(e)}
                  />
                  <label htmlFor="2">Website Development</label>
                </div>
                <div className="checkbox">
                  <input
                    id="3"
                    type="checkbox"
                    value="Video animation"
                    onChange={(e) => {
                      handleCheckBox(e);
                    }}
                  />
                  <label htmlFor="3">Video Animation</label>
                </div>
                <div className="checkbox">
                  <input
                    id="5"
                    type="checkbox"
                    value="Marketing"
                    onChange={(e) => {
                      handleCheckBox(e);
                    }}
                  />
                  <label htmlFor="5">Marketing</label>
                </div>
                <div className="checkbox">
                  <input
                    id="6"
                    type="checkbox"
                    value="Ecommerce Website"
                    onChange={(e) => {
                      handleCheckBox(e);
                    }}
                  />
                  <label htmlFor="6">Ecommerce Website</label>
                </div>
              </div>

              <div className="checkBoxRht">
                <div className="checkbox">
                  <input
                    id="7"
                    type="checkbox"
                    value=" User Experience (UX) Design"
                    onChange={(e) => {
                      handleCheckBox(e);
                    }}
                  />
                  <label htmlFor="7">User Experience (UX) Design</label>
                </div>
                <div className="checkbox">
                  <input
                    id="8"
                    type="checkbox"
                    value="Application Development"
                    onChange={(e) => handleCheckBox(e)}
                  />
                  <label htmlFor="8">Application Development</label>
                </div>
                <div className="checkbox">
                  <input
                    id="9"
                    type="checkbox"
                    value="SEO"
                    onChange={(e) => handleCheckBox(e)}
                  />
                  <label htmlFor="9">SEO</label>
                </div>
                <div className="checkbox">
                  <input
                    id="10"
                    type="checkbox"
                    value="Branding"
                    onChange={(e) => handleCheckBox(e)}
                  />
                  <label htmlFor="10">Branding</label>
                </div>
                <div className="checkbox">
                  <input
                    id="11"
                    type="checkbox"
                    value="other"
                    onChange={(e) => handleCheckBox(e)}
                  />
                  <label htmlFor="11">Other</label>
                </div>
              </div>
            </div>
            <Heading> tell us about the project</Heading>
            <div className="formTextarea">
              {/* <div className="inputField"> */}
              <textarea
                type="text"
                name="project_description"
                onChange={handleInputChange}
                value={state.project_description}
                placeholder="Requirements, goals, intentions, target audience etc *"
              />
              {/* </div> */}
            </div>
            <div
              className="formButton"
              // onClick={handleButtonClick}
              onClick={(e) => {
                // e.preventDefault()
                handleSubmit();
              }}
            >
              <div className="simple-button">
                <button> send inquiry </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Animation />
      <Footer />
    </div>
  );
};

export default StartProject;
